import { useSchemeProductQuery } from '~/gql/generated/graphql'

export const useSchemeProduct = ({ schemeProductId }) => {
  const { data, ...rest } = useSchemeProductQuery({
    variables: { schemeProductId },
    pollInterval: 0,
    errorPolicy: 'all',
  })

  // Extract price.amount to populate form values
  const initialValues = data?.scheme_product
    ? {
        ...data?.scheme_product,
        amount: data?.scheme_product?.price.amount,
        // Map this different field name, validity_interval on the input expects a string
        // but we're now using the enum value.
        validity: data?.scheme_product?.validity_interval,
      }
    : undefined

  return {
    ...rest,
    data,
    initialValues,
  }
}
